module.exports = __webpack_public_path__ + "img/symbol_7.17a1acd7.png";